import * as React from "react";
import axios from "axios"; // Import axios
import Header from "./Header.js";
import Footer from "./Footer.js";
import "./ContactUs.css"; // Connect the CSS file

function ContactUs() {
  const [formData, setFormData] = React.useState({
    project_name: "",
    project_details: "",
    partnership_type: "marketing", // Default value
    pic_name: "",
    pic_telegram: "",
    pic_email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log("Form data updated:", { ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send data to the new WordPress REST API endpoint
      const response = await axios.post(
        "https://keepityourself.com/wp-json/custom/v1/contact",
        {
          project_name: formData.project_name,
          project_details: formData.project_details,
          partnership_type: formData.partnership_type,
          pic_name: formData.pic_name,
          pic_telegram: formData.pic_telegram,
          pic_email: formData.pic_email,
        }
      );

      alert("Form submitted successfully!");
      console.log(response.data);
    } catch (err) {
      console.error("Form submission failed:", err.response?.data || err.message);
      alert("Submission failed. Check the console.");
    }
  };

  return (
    <>
      <Header />
      <div className="desktop-1">
        <div className="contact-div">
          <div className="contactus-header">Contact Us</div>
          <br />
          <br />
          <form className="contact-form" onSubmit={handleSubmit}>
            <label className="contact-label">
              Project Name:
              <input
                type="text"
                name="project_name"
                value={formData.project_name}
                onChange={handleChange}
                placeholder="Enter your project name"
                className="contact-input"
              />
            </label>
            <label className="contact-label">
              Project Details:
              <textarea
                name="project_details"
                value={formData.project_details}
                onChange={handleChange}
                placeholder="Enter your project details"
                className="contact-textarea"
              />
            </label>
            <label className="contact-label">
              Type of Partnership:
              <select
                name="partnership_type"
                value={formData.partnership_type}
                onChange={handleChange}
                className="contact-select"
              >
                <option value="marketing">Marketing</option>
                <option value="collaboration">Collaboration</option>
                <option value="sponsorship">Sponsorship</option>
              </select>
            </label>
            <label className="contact-label">
              Person In Charge (PIC) Name:
              <input
                type="text"
                name="pic_name"
                value={formData.pic_name}
                onChange={handleChange}
                placeholder="Enter PIC name"
                className="contact-input"
              />
            </label>
            <label className="contact-label">
              Person In Charge (PIC) Telegram Handle:
              <input
                type="text"
                name="pic_telegram"
                value={formData.pic_telegram}
                onChange={handleChange}
                placeholder="Enter PIC Telegram handle"
                className="contact-input"
              />
            </label>
            <label className="contact-label">
              Person In Charge (PIC) Email:
              <input
                type="email"
                name="pic_email"
                value={formData.pic_email}
                onChange={handleChange}
                placeholder="Enter PIC email"
                className="contact-input"
              />
            </label>
            <button type="submit" className="contact-submit">
              Submit
            </button>
          </form>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default ContactUs;
